import { twMerge } from 'tailwind-merge';

interface IPageHeader {
  title: string;
  classNames?: string;
}

const PageHeader = ({ title, classNames }: IPageHeader) => {
  return (
    <div
      className={twMerge(
        'px-[15px] w-full pb-3 border-b-[1px] border-shadow-3 border-solid',
        classNames,
      )}>
      <div className="text-[18px] text-left">{title}</div>
    </div>
  );
};

export default PageHeader;
